import React from 'react';

function VanIcon() {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M23.4 13.2H22.8V9.14628C22.8 8.67 22.6087 8.21256 22.2713 7.875L18.525 4.12874C18.1874 3.79124 17.73 3.6 17.2537 3.6H15.6V1.8C15.6 0.806256 14.7937 0 13.8 0H4.2C3.20626 0 2.4 0.806256 2.4 1.8V3.6H0.3C0.135 3.6 0 3.735 0 3.9V4.5C0 4.665 0.135 4.8 0.3 4.8H10.5C10.665 4.8 10.8 4.935 10.8 5.1V5.7C10.8 5.865 10.665 6 10.5 6H1.5C1.335 6 1.2 6.135 1.2 6.3V6.9C1.2 7.065 1.335 7.2 1.5 7.2H9.3C9.465 7.2 9.6 7.335 9.6 7.5V8.1C9.6 8.265 9.465 8.4 9.3 8.4H0.3C0.135 8.4 0 8.535 0 8.7V9.3C0 9.465 0.135 9.6 0.3 9.6H8.1C8.265 9.6 8.4 9.735 8.4 9.9V10.5C8.4 10.665 8.265 10.8 8.1 10.8H2.4V15.6C2.4 17.5874 4.0125 19.2 6 19.2C7.9875 19.2 9.6 17.5874 9.6 15.6H14.4C14.4 17.5874 16.0126 19.2 18 19.2C19.9874 19.2 21.6 17.5874 21.6 15.6H23.4C23.73 15.6 24 15.33 24 15V13.8C24 13.47 23.73 13.2 23.4 13.2ZM6 17.4C5.00626 17.4 4.2 16.5937 4.2 15.6C4.2 14.6063 5.00626 13.8 6 13.8C6.99374 13.8 7.8 14.6063 7.8 15.6C7.8 16.5937 6.99374 17.4 6 17.4ZM18 17.4C17.0063 17.4 16.2 16.5937 16.2 15.6C16.2 14.6063 17.0063 13.8 18 13.8C18.9937 13.8 19.8 14.6063 19.8 15.6C19.8 16.5937 18.9937 17.4 18 17.4ZM21 9.6H15.6V5.4H17.2537L21 9.14628V9.6Z"
        fill="#2A61EF"
      />
    </svg>
  );
}

VanIcon.propTypes = {};

export default VanIcon;
